import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, timer } from 'rxjs';
import { CardTransactionService } from '../card-operations/services/getCardTransactions.service';
import { TransactionRequestService } from '../card-operations/services/transactionRequest.service';
import { Service3dsRequest } from '../card-operations/services/3dsRequest.service';
import { TransactionCompleteService } from '../card-operations/services/transactionComplete.service';
import { AppConfig } from '../config-service/app.config';
import { CardOperationsMediator, EtisalatCardOperationsMediator } from './utility-classes/etisalat-online-charge-mediator';

@Component({
  selector: 'app-card-operations',
  templateUrl: './card-operations.component.html',
  styleUrls: ['./card-operations.component.css'],
})
export class CardOperationsComponent implements OnInit {
  @Input() modalType!: string;
  @Input() modalInput!: string;

  public onlineChargeMediatorClass: CardOperationsMediator = new EtisalatCardOperationsMediator();

  isLoading = false;
  apiSettings = AppConfig.settings;
  queryAlias = '';

  constructor(
    public activeModal: NgbActiveModal,
    public restGetCardTransations: CardTransactionService,
    public restTransactionRequest: TransactionRequestService,
    public content3dsService: Service3dsRequest,
    public restTransactionComplete: TransactionCompleteService,
  ) {}

  ngOnInit(): void {}
  
  get onlineChargeMediator(){
    return this.onlineChargeMediatorClass;
  }

  onError(){
    this.activeModal.dismiss('Cross click');
  }

}